// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kore-chat-window .system-template {
  position: relative;
  border-bottom: 1px solid var(--sdk-chat-widow-primary-border-color);
  margin-bottom: 30px;
  font-weight: 400;
  margin-top: 20px;
}

.kore-chat-window .system-template-msg {
  position: relative;
  top: 12px;
  background: var(--sdk-chat-widow-default-white);
  padding: 0px 10px;
  display: initial;
  width: 137px;
  color: #333;
  margin-left: 20px;
  margin-top: 43x;
  font-weight: bold;
  font-size: 12px;
}`, "",{"version":3,"sources":["webpack://./src/plugins/v2Plugin/templates/systemTemplate/systemTemplate.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,mEAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,SAAA;EACA,+CAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;AACJ","sourcesContent":[".kore-chat-window .system-template {\n    position: relative;\n    border-bottom: 1px solid var(--sdk-chat-widow-primary-border-color);\n    margin-bottom: 30px;\n    font-weight: 400;\n    margin-top: 20px;\n}\n\n.kore-chat-window .system-template-msg {\n    position: relative;\n    top: 12px;\n    background: var(--sdk-chat-widow-default-white);\n    padding: 0px 10px;\n    display: initial;\n    width: 137px;\n    color: #333;\n    margin-left: 20px;\n    margin-top: 43x;\n    font-weight: bold;\n    font-size: 12px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
